import { NgModule } from "@angular/core";
import { CommonComponentsModule } from "src/app/common-components";
import { CommonModule } from "@angular/common";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { RouterModule } from "@angular/router";
import { PlanungApiTaskDetailSidebarComponent } from "./sidebar/sidebar.component";
import { PlanungApiTaskContactModule } from "../task-contact/task-contact.module";
import { AnlageApiComponentsModule } from "src/app/anlage-api/components/anlage-components.module";
import { FormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { SpinnerModule } from "src/app/common-components/spinner/spinner.module";
import { FormularEditorModule } from "../formular/edit/task-formular-edit.module";
@NgModule({
    imports: [
        CommonModule,
        ScrollingModule,
        CommonComponentsModule,
        RouterModule,
        AnlageApiComponentsModule,
        PlanungApiTaskContactModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        SpinnerModule,
        FormularEditorModule
    ],
    declarations: [PlanungApiTaskDetailSidebarComponent],
    exports: [PlanungApiTaskDetailSidebarComponent, FormularEditorModule],
})
export class PlanungApiTaskDetailModule { }
